(() => {
  'use strict';

  /*
   * =========================================================
   * THE SEVENTH SENSE
   * ZENTRALE PRODUKTBILD-LOGIK
   * =========================================================
   *
   * Produktgruppen werden oben konfiguriert.
   * Die eigentliche Logik darunter bleibt stabil.
   *
   * linkedImage:
   * Bild für verlinkte Produktdarstellungen
   * z.B. Warenkorb, Cart Drawer, Empfehlungen, Produktkarten
   *
   * productPageThumbnail:
   * Optionales Bild für das kleine Thumbnail
   * auf der eigentlichen Produktseite
   *
   * excludePages:
   * Seiten, auf denen die verlinkte Bild-Ersetzung
   * NICHT greifen soll
   * =========================================================
   */

  const PRODUCT_GROUPS = {
    /*
     * ---------------------------------------------------------
     * GIN PERSONALISIEREN
     * ---------------------------------------------------------
     */
    gin: {
      match: 'gin-personalisieren',

      linkedImage:
        'https://cdn.shopify.com/s/files/1/1082/4928/4947/files/4c9e59_2546b7bcae5742a3a10f4006757ac703_mv2.png?v=1787408976',

      productPageThumbnail:
        'https://cdn.shopify.com/s/files/1/1082/4928/4947/files/4c9e59_2546b7bcae5742a3a10f4006757ac703_mv2.png?v=1787408976',

      excludePages: []
    },

    /*
     * ---------------------------------------------------------
     * YOUR DRINK YOUR BOX – BASIC SETS
     *
     * Aktuell:
     * - rum-spicey-basic-set
     * - salin-grape-basic-set
     * - swiss-mule-box-basic-set
     * - tiki-lemonade-box-basic-set
     *
     * Alle Produkte mit "basic-set" im Handle
     * werden automatisch erfasst.
     * ---------------------------------------------------------
     */
    basicBoxes: {
      match: 'basic-set',

      linkedImage:
        'https://cdn.shopify.com/s/files/1/1082/4928/4947/files/Box.png?v=1788015645',

      /*
       * YDYB besitzt eigene gestaltete Kacheln.
       * Dort dürfen die Bilder nicht ersetzt werden.
       */
      excludePages: [
        '/pages/ydyb'
      ]
    }
  };


  /*
   * =========================================================
   * HILFSFUNKTIONEN
   * =========================================================
   */

  function currentPath() {
    return window.location.pathname;
  }

  function isExcludedPage(group) {
    if (!group.excludePages || !group.excludePages.length) {
      return false;
    }

    return group.excludePages.some((path) =>
      currentPath().startsWith(path)
    );
  }

  function replaceImage(img, newImage) {
    if (!img || !newImage) {
      return;
    }

    if (img.dataset.tssImageOverride === newImage) {
      return;
    }

    /*
     * Responsive / Lazyload-Quellen entfernen,
     * damit Shopify / Emporium nicht wieder
     * das ursprüngliche Bild einsetzt.
     */
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-sizes');

    const picture = img.closest('picture');

    if (picture) {
      picture.querySelectorAll('source').forEach((source) => {
        source.removeAttribute('srcset');
        source.removeAttribute('sizes');
        source.removeAttribute('data-srcset');
        source.removeAttribute('data-sizes');
      });
    }

    img.src = newImage;

    /*
     * Kennzeichnung für DevTools.
     */
    img.dataset.tssImageOverride = newImage;
  }


  /*
   * =========================================================
   * VERLINKTE PRODUKTBILDER
   * =========================================================
   *
   * Betrifft z.B.:
   * - Cart Drawer
   * - Warenkorb
   * - Produktkarten
   * - verwandte Produkte
   *
   * Die eigentliche Produktgalerie wird hier nicht verändert.
   * =========================================================
   */

  function applyLinkedProductOverrides() {
    Object.values(PRODUCT_GROUPS).forEach((group) => {
      if (!group.linkedImage) {
        return;
      }

      if (isExcludedPage(group)) {
        return;
      }

      document
        .querySelectorAll(`a[href*="${group.match}"] img`)
        .forEach((img) => {
          /*
           * Zusätzliche Absicherung:
           * YDYB-Karten niemals verändern.
           */
          if (img.closest('.ydydb-box-card')) {
            return;
          }

          replaceImage(img, group.linkedImage);
        });
    });
  }


  /*
   * =========================================================
   * GIN – PRODUKTSEITEN-THUMBNAIL
   * =========================================================
   *
   * Nur beim Gin ersetzen wir zusätzlich
   * das kleine Thumbnail der Produktgalerie.
   * =========================================================
   */

  function applyGinProductPageThumbnail() {
    const group = PRODUCT_GROUPS.gin;

    if (!currentPath().includes(group.match)) {
      return;
    }

    if (!group.productPageThumbnail) {
      return;
    }

    document
      .querySelectorAll('[data-product-media-thumbnail-button] img')
      .forEach((img) => {
        replaceImage(img, group.productPageThumbnail);
      });
  }


  /*
   * =========================================================
   * ALLE REGELN AUSFÜHREN
   * =========================================================
   */

  function applyImageOverrides() {
    applyLinkedProductOverrides();
    applyGinProductPageThumbnail();
  }


  /*
   * =========================================================
   * INITIALER START
   * =========================================================
   *
   * Emporium rendert manche Elemente zeitversetzt.
   * Deshalb mehrere Durchläufe.
   * =========================================================
   */

  function runOverrides() {
    applyImageOverrides();

    setTimeout(applyImageOverrides, 250);
    setTimeout(applyImageOverrides, 750);
    setTimeout(applyImageOverrides, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      runOverrides
    );
  } else {
    runOverrides();
  }


  /*
   * =========================================================
   * DYNAMISCHE EMPORIUM-UPDATES
   * =========================================================
   */

  let updateScheduled = false;

  const observer = new MutationObserver(() => {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    requestAnimationFrame(() => {
      applyImageOverrides();
      updateScheduled = false;
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * =========================================================
   * WARENKORB-EVENT
   * =========================================================
   */

  document.addEventListener('Themu:cart:add', () => {
    requestAnimationFrame(applyImageOverrides);
  });

})();